import { createFileRoute } from '@tanstack/react-router';

import { LanguagePage } from '~/features/onboarding/language/language-page';

/** The app language: chosen once, after the email is verified and before setup. */
export const Route = createFileRoute('/onboarding/language')({
  component: LanguagePage,
});
